// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media print{thead{display:table-header-group}tfoot{display:table-footer-group}body{margin:0}}.print-page{page-break-after:always}.fullscreen-panel{position:absolute;top:0;left:0;right:0;z-index:3000;background-color:#fff;min-height:100%}.print-header{top:0}.print-footer,.print-header{position:fixed;left:0;right:0}.print-footer{bottom:0}", ""]);
// Exports
module.exports = exports;
